import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray, AbstractControl, ValidationErrors } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { OtherAuthComponent } from '../other-auth/other-auth.component';
import { LoginComponent } from '../login/login.component';
import { InternationalauthService } from 'src/app/_service/internationalauth.service';
import { AuthenticateserviceService } from 'src/app/_service/authenticateservice.service';
import Fingerprint2 from 'fingerprintjs2';

@Component({
  selector: 'app-other-registration',
  templateUrl: './other-registration.component.html',
  styleUrls: ['./other-registration.component.css']
})
export class OtherRegistrationComponent implements OnInit {

  intRegFormGroup:FormGroup;
  regStep = 1;
  imageUrl: string | ArrayBuffer = '../../../assets/img/profile_avatar.png';
  file:any;
  errorMessage:string;
  deviceId:any;

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<OtherRegistrationComponent>,
    private internationalAuth: InternationalauthService,
    private authService: AuthenticateserviceService
  ) { 
    if(localStorage.getItem('deviceId')){
      this.deviceId = localStorage.getItem('deviceId');
    }else{
      this.generateFingerprint();
    }
    this.intRegFormGroup = this.fb.group({
      userName: [
        '@', 
        [Validators.required, Validators.minLength(5), Validators.maxLength(20), this.alphanumericValidator] 
      ],
      screenName: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(20)]],
      email: ['', [Validators.required, Validators.email]],
      aboutMe: [''],
      pin1: this.fb.array(
        new Array(4).fill('').map(() => this.fb.control('', [Validators.required])),
        Validators.required
      ),
      pin2: this.fb.array(
        new Array(4).fill('').map(() => this.fb.control('', [Validators.required])),
        Validators.required
      ),
    })
  }

  generateFingerprint(): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      Fingerprint2.get((components) => {
        const values = components.map((component) => component.value);
        this.deviceId = Fingerprint2.x64hash128(values.join(''), 31);
        localStorage.setItem('deviceId', this.deviceId);
        resolve(this.deviceId);
      });
    });
  }

  ngOnInit(): void {

  }

  next(){
    this.regStep = 2;
  }

  submit(){
    if(this.intRegFormGroup.valid){
      if(this.doPinsMatch()){
        const formValue = this.intRegFormGroup.value;
        const requestBody = {
          'screenName': formValue.screenName,
          'pin': this.pinArray2.value.join(''),
          'recoveryMail': formValue.email,
          'username': formValue.userName,
          'deviceId': this.deviceId,
          'deviceType': 'WEB',
          'fbTokenId': 'fbtokenid',
          'description': formValue.aboutMe
        }

        this.internationalAuth.internationalSignUp(requestBody).subscribe((result)=>{
          if(result){
            window.location.reload();
            if(this.file){
              this.uploadImage();
            }
          }else{
            alert('User not found');
          }        
        },(error)=>{
          this.regStep = 1;
          this.errorMessage = error?.error.message;
          this.intRegFormGroup.reset();
        })
        console.log(requestBody)
      }else{
        this.errorMessage = 'Pin does not match';
      }
    }
  }

  uploadImage(){
    if(this.file){
      const formData = new FormData(); 
      formData.append("photo", this.file);
      formData.append('tqr_user_id', localStorage.getItem('userId'));
      this.authService.uploadUserProfileImage(formData).subscribe( res => {
        console.log("image upload success", res);
        localStorage.setItem('profileImage', res.img_name)
      })
    }
  }

  get pinArray1() {
    return this.intRegFormGroup.get('pin1') as FormArray;
  }

  get pinArray2() {
    return this.intRegFormGroup.get('pin2') as FormArray;
  }

  createPinFormArray(): FormArray {
    return this.fb.array(Array(6).fill('').map(() => this.fb.control('', Validators.required)));
  }

  validatePin(control: FormArray): { [key: string]: boolean } | null {
    const isNumeric = control.controls.every(ctrl => /^\d$/.test(ctrl.value));
    const isComplete = control.controls.every(ctrl => ctrl.value);
    if (!isComplete) {
      return { required: true };
    }
    if (!isNumeric) {
      return { nonNumeric: true };
    }
    return null;
  }

  uploadFile(event) {
    let reader = new FileReader();
    this.file = event.target.files[0];
    if (event.target.files && event.target.files[0]) {
      reader.readAsDataURL(this.file);
      reader.onload = () => {
        this.imageUrl = reader.result;
      }
    }
  }

  updateFile(event: any) {
    const userId = localStorage.getItem('userId');
    let reader = new FileReader();
    if (event.target.files && event.target.files[0]) {
      let originalFile = event.target.files[0];
      const renamedFile = new File([originalFile], `${userId}_thumbnail.jpg`, {
        type: originalFile.type,
      });
      this.file = renamedFile;
      reader.readAsDataURL(this.file);
      reader.onload = () => {
        this.imageUrl = reader.result; 
      };
    }
  }

  alphanumericValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value.substring(1); 

    const hasAlphabet = /[a-zA-Z]/.test(value); 
    const hasNumber = /\d/.test(value); 

    if (!hasAlphabet || !hasNumber) {
      return { alphanumeric: true }; 
    }
    return null; 
  }

  onUserHandlerInput(event: KeyboardEvent){
    const input = event.target as HTMLInputElement;

    if(input.selectionStart === 0){
      event.preventDefault();
      input.setSelectionRange(1,1);
    }

    if(!input.value.startsWith('@')){
      input.value = '@' + input.value.replace('@', '');
      this.intRegFormGroup.get('userHandler')?.setValue(input.value);
    }
  }

  onInput(event: any, index: number, pinGroup: string): void {
    const inputValue = event.target.value;
    if (inputValue && index < 3) {
      const nextInput = document.getElementById(`${pinGroup}${index + 1}`) as HTMLInputElement;
      if (nextInput) {
        nextInput.focus();
      }
    }
  }

  onKeyDown(event: KeyboardEvent, index: number, pinGroup: string): void {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      if (index > 0) {
        const prevInput = document.getElementById(`${pinGroup}${index - 1}`) as HTMLInputElement;
        if (prevInput) {
          prevInput.focus();
        }
      }
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      if (index < 3) {
        const nextInput = document.getElementById(`${pinGroup}${index + 1}`) as HTMLInputElement;
        if (nextInput) {
          nextInput.focus();
        }
      }
    }
  }

  onInputKeyUp(event: KeyboardEvent, index: number, pinGroup: string): void {
    if (event.key === 'Backspace') {
      event.preventDefault();
      if (index > 0) {
        const currentInput = document.getElementById(`${pinGroup}${index}`) as HTMLInputElement;
        if (currentInput) {
          currentInput.value = '';
          const prevInput = document.getElementById(`${pinGroup}${index - 1}`) as HTMLInputElement;
          if (prevInput) {
            prevInput.focus();
          }
        }
      }
    } else {
      const inputValue = (event.target as HTMLInputElement).value;
      if (!/^\d$/.test(inputValue)) {
        event.preventDefault();
      }
    }
  }

  doPinsMatch(): boolean {
    const pin1 = this.intRegFormGroup.get('pin1').value.join('');
    const pin2 = this.intRegFormGroup.get('pin2').value.join('');
    return pin1 === pin2;
  }

  showPin1:boolean;
  togglePin1(){
    this.showPin1 = !this.showPin1;
  }
  showPin2:boolean;
  togglePin2(){
    this.showPin2 = !this.showPin2;
  }

  openLogin(){
    this.dialogRef.close();
    const dialogRef = this.dialog.open(LoginComponent,{
      height:'90vh',
      panelClass: 'custom-dialog-container'
    })
  }
}
